const integrations = (state = [], action = { type: '', payload: [] }) => {
  switch (action.type) {
    case 'GET_INTEGRATIONS_SUCCESS':
      return action.payload
    case 'GET_INTEGRATIONS_FAIL':
      return state
    case 'REMOVE_INTEGRATION_SUCCESS':
      return state.filter(s => s !== action.payload.service)
    case 'REMOVE_INTEGRATION_FAIL':
      return state
    default:
      return state
  }
}

export default integrations
